import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../e-met/services/data.service';
import {
    NgbAlertModule,
    NgbDatepickerModule,
    NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../e-met/services/shared.service';
import { LocalStorageService } from '../../core/services/local-storage.service';
import * as utils from '../../e-met/services/utility-functions';
@Component({
    selector: 'app-documents-submitable',
    templateUrl: './documents-submitable.component.html',
    styleUrls: ['./documents-submitable.component.scss'],
})
export class DocumentsSubmitableComponent implements OnInit {
    @Input() data: any;
    model: NgbDateStruct;
    constructor(
        private dataService: DataService,
        private sharedService: SharedService,
        private localStorage : LocalStorageService
    ) {}

    ngOnInit(): void {

        this.sharedService.documentListSubmitter$.subscribe((status) => {
            if (status.submit == true) {
                this.submitDocuments();
            }
        });
    }

    validateInput(event: any) {
      const input = event.target;
      // Allow English letters (A-Z, a-z), Greek letters, and numbers (0-9)
      const regex = /[^A-Za-z0-9Α-Ωα-ω]/g;
      input.value = input.value.replace(regex, '');
    }

    handleFileChange($event, appId) {
      let parent = $event.target.parentElement;
      let file = (<HTMLInputElement>parent.querySelector('input[type=file]')).files;
      const documentId = (document.querySelector('#documentIdInput') as HTMLInputElement)?.value;

      if (!utils.isPdfFileType(file[0].type)) {
        const errorMessage =
            'Το υπο μεταφορτώση αρχείο πρέπει να είναι σε μορφή PDF.';
        this.dataService.onFailUpdateDocument(errorMessage);
        return;
      }

      if (!utils.isFileSizeValid(file[0].size, 2000000)) {
        const errorMessage =
            'Το υπο μεταφορτώση αρχείο δεν πρέπει να ξεπερνά σε μέγεθος το 1MB.';
        this.dataService.onFailUpdateDocument(errorMessage);
        return;
      }

      //let fileholder = parent.querySelector('.file-holder');
      //fileholder.innerHTML = file[0].name;

      this.dataService
      .uploadCadastreDocuments(appId, documentId, '01', '1', file[0])
      .subscribe(
        (data) => {
          const message = 'Το αρχείο ' + file[0].name +' μεταφορτώθηκε επιτυχώς';
          this.dataService.onSuccessUpdateDocument(message);
        },
        (error) => {
          const errorMessage =
            'Προέκυψε σφάλμα κατά την μεταφόρτωση.';
          this.dataService.onFailUpdateDocument(errorMessage);
        }
      );
    }

    preview($event) {
        let parent = $event.target.parentElement;

        let myFile = (<HTMLInputElement>(
            parent.querySelector('input[type=file]')
        )).files[0];

        this.dataService.showFileInNewTab(myFile);
    }
    submitDocuments() {
        let documentObject = [];
        let table = document.querySelector('.documentsContractTable');
        const cadastreInput = <HTMLInputElement>(
            document.getElementById('documentCadastre')
        );
        documentObject.push({
            documentId: (<HTMLInputElement>(
                table.querySelector('input[name=documentId]')
            )).value,
            calendardate: (<HTMLInputElement>(
                table.querySelector('input[name=calendardate]')
            )).value,
            file: cadastreInput.files,
        });
        this.sharedService.updateDocumentListData(documentObject);
    }

    uploadDocument() {
      const documentId = (document.querySelector('#documentIdInput') as HTMLInputElement)?.value;
      console.log('documentId = ',documentId);
      if (documentId === '') {
        const errorMessage =
            'Για να μεταφορτώσετε το συμβόλαιο θα πρέπει να έχετε προηγουμένως συμπληρώσει Αρ.Εγγράφου.';
        this.dataService.onFailUpdateDocument(errorMessage);
        return;
      }
      else {
        document.getElementById('documentCadastre').click();
      }
    }

    documentAction(appId, id) {
      // #ΤΟDO - Getting information with query selector at this stage is only meant as a temp patch
      // Instead form groups should be passed from parent components and be used for that purpose
      const documentId = (document.querySelector('#documentIdInput') as HTMLInputElement)?.value;

      if (documentId === '') {
        const errorMessage =
            'Δεν έχετε συμπληρωμένο Αρ.Εγγράφου.';
        this.dataService.onFailUpdateDocument(errorMessage);
        return;
      } else {
        this.dataService.getContractDocuments(appId, documentId).subscribe(
            (response) => {
                this.dataService.showFileInNewTab(response.body);
            },
            (error) => {
                console.log('error');
                const errorMessage =
                  'Δεν έχετε μεταφορτώσει συμβόλαιο.';
                this.dataService.onFailUpdateDocument(errorMessage);
                return;
            }
        );
      }
  }

  onBlurMethod($event, oldValue) {
    let errorMessage = '';
    /*
    if (!$event.target.value) {
        return;
    }
    */
    //console.log('name = ', $event.target.name);
    //console.log('value = ', $event.target.value);

    let textAndNumbersRegexMsg = 'θα πρέπει να περιέχει μόνο γράμματα και αριθμούς.';
    let onlyDateRegexMsg = 'θα πρέπει να έχει τη μορφή ημερομηνίας.';

    if ($event.target.name === 'documentId' && !utils.textAndNumbersRegex($event.target.value)) {
      errorMessage += 'Ο Αρ. Εγγράφου ' + textAndNumbersRegexMsg;
    }
    else if ($event.target.name === 'calendardate' && !utils.onlyDateRegex($event.target.value?.replaceAll('-','/'))) {
      errorMessage += 'Η Ημ/νία Εγγράφου ' + onlyDateRegexMsg;
    }
    else if ($event.target.name === 'documentCadastre' && $event.target.value === '') {
      errorMessage += 'Πρέπει να μεταφορτώσετε Συμβόλαιο.';
    }
    //console.log('errorMessage = ', errorMessage);

    if (errorMessage !== '') {
      if (oldValue) {
        $event.target.value = oldValue;
      }
      this.dataService.onFailFormFieldsValidation(errorMessage);
      return;
    }
  }


  clickHandler(methodName: string, arg: any){
    if (typeof this[methodName] === 'function') {
      this[methodName](arg);
    }
  }

  downloadTemplate(appId){
    this.dataService.getTemplateDoc(appId);
  }


}
